module.exports = __webpack_public_path__ + "static/media/Ticket Hoss Collapsed Menu Logo.79a82c10.svg";